import {Injectable} from '@angular/core';
import {filter, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import flashDrivePricesData from '../data/flash-disk-prices_final.json';

@Injectable({
  providedIn: 'root'
})
export class FlashDrivePrices {
  private flashDrivePrices: any[] = flashDrivePricesData;

  constructor() {
  }

  /**
   * Returns an Observable that emits an array of unique brand names.
   */
  getBrands(): Observable<string[]> {
    const data = of(this.flashDrivePrices).pipe(
      // 1. Map all products to their brand name.
      map(products => products.map(item => item.brand)),

      // 2. Filter to ensure we only have actual, non-empty strings. THIS IS THE FIX.
      map(brands => brands.filter(brand => typeof brand === 'string' && brand.trim() !== '')),

      // 3. Create the unique set from the cleaned array.
      map(filteredBrands => [...new Set(filteredBrands)])
    );

    return data;
  }

  /**
   * Returns an Observable that emits an array of unique hardware interface names.
   */
  getHardwareInterfaces(): Observable<string[]> {
    return of(this.flashDrivePrices).pipe(
      // 1. Map all products to their hardware interface.
      map(products => products.map(item => item.hardware_interface)),

      // 2. Filter out any null, undefined, or empty string values.
      map(interfaces => interfaces.filter(iface => typeof iface === 'string' && iface.trim() !== '')),

      // 3. Create a unique set from the cleaned array.
      map(filteredInterfaces => [...new Set(filteredInterfaces)])
    );
  }


  // /**
  //  * Returns an Observable that emits a formatted list of flash drive price data.
  //  */
  // getFlaskDrivePrices(): Observable<any> {
  //   const data = of(this.flashDrivePrices).pipe(
  //     map(prices => prices.map( item=> ({
  //       title: item.title,
  //       brand: item.brand,
  //       capacity: item.capacity_raw,
  //       interface: item.hardware_interface,
  //       price: item.price_numeric,
  //       currency: item.currency,
  //       type: item.memory_type,
  //       link: item?.affiliate_link?.trim()
  //     })))
  //   )
  //   return data;
  // }

  getFlaskDrivePrices(): Observable<any> {
    const data = of(this.flashDrivePrices).pipe(
      filter((prices) => prices.length > 0), // Ensure there are prices
      map((prices) =>
        prices
          .filter((item) => item.affiliate_link && item.affiliate_link.trim() !== '') // Filter out items with blank/null links
          .map((item) => ({
            title: item.title,
            brand: item.brand,
            capacity: item.capacity_raw,
            interface: item.hardware_interface,
            price: item.price_numeric,
            currency: item.currency,
            type: item.memory_type,
            link: item.affiliate_link.trim(), // Trim is safe now
          }))
      )
    );
    return data;
  }
}
